import React, { useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import { useSelector } from "react-redux";

import CarrierOfferList from "./components/OfferList";
import OrderNavigations from "./components/OrderNavigations";

const Carrier = () => {
  const userData = useSelector((state) => state.basicInfo.userDetails);

  // Only carrier can visit this page
  useEffect(() => {
    if (userData?.user_type && userData.user_type !== "carrier") window.location.href = "/";
  }, []);

  return (
    <>
      <Routes>
        <Route path="/offer-list" element={<CarrierOfferList />} />
        <Route path="/order-navigations" element={<OrderNavigations />} />
      </Routes>
    </>
  );
};

export default Carrier;
